import fetchAPI from '../../fetchAPI';
import { useQuery, keepPreviousData } from '@tanstack/react-query';

type Props = {
  locationId?: string;
  status?: string;
  companyName?: string;
  startDate?: string | null;
  endDate?: string | null;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string | string[];
};

export const useCoreDetailedList = <T>(props: Props) => {
  const {
    pageNumber,
    pageSize,
    companyName,
    sortBy,
    status,
    locationId,
    startDate,
    endDate,
  } = props;

  const queryParams = new URLSearchParams();
  if (locationId) {
    queryParams.append('locationId', locationId.toString());
  }
  if (pageNumber) {
    queryParams.append('pageNumber', pageNumber.toString());
  }
  if (pageSize) {
    queryParams.append('pageSize', pageSize.toString());
  }
  if (companyName) {
    queryParams.append('companyName', companyName);
  }
  if (status) {
    queryParams.append('status', status);
  }
  if (endDate && endDate != null) {
    queryParams.append('endDate', endDate);
  }
  if (startDate && startDate != null) {
    queryParams.append('startDate', startDate);
  }
  if (sortBy) {
    if (Array.isArray(sortBy)) {
      sortBy.forEach((sort) => queryParams.append('sortBy', sort));
    } else {
      queryParams.append('sortBy', sortBy);
    }
  }
  return useQuery({
    queryKey: [`core/detailed-list`, locationId, status, companyName, startDate, endDate, pageNumber, pageSize, sortBy],
    queryFn: async () => {
      const response = await fetchAPI<T>({
        method: 'GET',
        route: `core/detailed-list`,
        queryString: queryParams.toString()
      });

      return response;
    },
    enabled: !!startDate && !!endDate, // Query will only run if range is provided
    placeholderData: keepPreviousData
  });
};

export default useCoreDetailedList;
